
/**
 * Establecer los idiomas.
 *
 * @param {*} state
 * @param {*} languages
 */
export function setLanguages(state, languages) {
    state.languages = languages
}
/**
 * Restablecer los idiomas.
 *
 * @param {*} state
 */
export function resetLanguages(state) {
    state.languages = []
}